import { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import OpenSeadragon from 'openseadragon';

type Response = {
	data?: string;
	urls?: string[];
};

export const useViewer = () => {
	const [open, setOpen] = useState(false);

	const [viewer, setViewer] = useState<OpenSeadragon.Viewer>();

	const [pages, setPages] = useState<number>(0);

	const [currentPage, setCurrentPage] = useState<number>(0);

	viewer?.addHandler('page', e => {
		if (e.page !== undefined) setCurrentPage(e.page);
	});

	useEffect(() => {
		setCurrentPage(0);
	}, [viewer]);

	const openViewer = (id?: string) => {
		setOpen(true);

		document.body.style.overflow = 'hidden';

		try {
			axios
				.get<Response>(`/api/scitacioperaty/archive/id/${id}`)
				.then(response => {
					if (response.data) {
						const completeUrls =
							response.data.urls?.map(url => `/api${url}`) ?? [];

						setPages(response.data.urls?.length ?? 0);

						setViewer(
							OpenSeadragon({
								id: 'image-viewer',
								showNavigator: true,
								showNavigationControl: false,
								showFlipControl: false,
								showRotationControl: false,
								showSequenceControl: false,
								showZoomControl: false,
								showHomeControl: false,
								showFullPageControl: false,
								tileSources: completeUrls,
								sequenceMode: true,
								showReferenceStrip: true,
								referenceStripScroll: 'vertical',
							}),
						);
					}
				});
		} catch (e) {
			console.error(e);

			throw e;
		}
	};

	const closeViewer = () => {
		setOpen(false);
		viewer?.destroy();
		setViewer(undefined);

		document.body.style.overflow = 'auto';
	};

	return { viewer, open, pages, currentPage, openViewer, closeViewer };
};

type ViewerContextType = {
	viewer?: OpenSeadragon.Viewer;
	open: boolean;
	pages: number;
	currentPage: number;
	openViewer: (id?: string) => void;
	closeViewer: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ViewerContext = createContext<ViewerContextType>(undefined as any);
